import target from './target.json';
import buyer from './buyer.json';

export default {
  target,
  buyer,
};
